import { render, staticRenderFns } from "./DeclinedForm.vue?vue&type=template&id=166fa71e&"
import script from "./DeclinedForm.vue?vue&type=script&lang=js&"
export * from "./DeclinedForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports